import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { Empty_KarshnasMasol_Interface, KarshnasMasol_Interface } from 'src/app/Interface/KarshnasMasol_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CustomerService } from 'src/app/Service/Customer/Customer.service';

@Component({
  selector: 'app-CutomerKarshnasForm',
  templateUrl: './CutomerKarshnasForm.component.html',
  styleUrls: ['./CutomerKarshnasForm.component.scss']
})
export class CutomerKarshnasFormComponent implements OnInit {
  @Input() inner_Customer: number = 0
  @Output() outter_KarshnasMasol = new EventEmitter<Array<KarshnasMasol_Interface>>();

  ngOnChanges(changes: SimpleChanges) {
    this.inner_Customer = changes.inner_Customer.currentValue

    this.ReadSemat()

  }

  constructor(
    private Alerify: AlertifyService,
    private Customer_Service: CustomerService,
  ) { }

  ngOnInit() {
    this.RabetMasolCustomer = new FormGroup({
      id: new FormControl(),
      FName: new FormControl(null),
      LName: new FormControl(null, Validators.required),
      Sex: new FormControl("1", Validators.required),
      Semat: new FormControl('', Validators.required),
      Mobile: new FormControl('', Validators.pattern('^[0-9]{10}$')),
      majaziMobile: new FormControl('', Validators.pattern('^[0-9]{10}$')),
      jaygozinMiblie: new FormControl('', Validators.pattern('^[0-9]{10}$')),
      Tel: new FormControl(''),
      Dsc: new FormControl(null),
      Type: new FormControl('0'),
      SmsActive: new FormControl('0'),
    })

  }

  OnInitail_Form() {
    this.Customer_Service.GetSingle(this.inner_Customer).subscribe(
      data => {

        console.log(data['karshnasMasol']);

        this.DataList_KarshnasMasol = data['karshnasMasol']
        for (let item of this.DataList_KarshnasMasol) {
          item.Dakhli = []

          for (let itemDetail of item.dakhli_temp.split(',')) {
            if (itemDetail != "-1") {
              item.Dakhli.push({
                id: 0,
                title: itemDetail,
                code: '',
                dsc: '',
                del: false,
                DeletingProccess: false
              })
            }

          }

          item.dakhli_temp = '-1'
        }

        for (let item of this.DataList_KarshnasMasol) {
          item.Email = []

          for (let itemDetail of item.email_temp.split(',')) {
            if (itemDetail != "-1") {
              item.Email.push({
                id: 0,
                title: itemDetail,
                code: '',
                dsc: '',
                del: false,
                DeletingProccess: false
              })
            }

          }
          item.email_temp = '-1'
        }

        for (let item of this.DataList_KarshnasMasol) {
          item.Tel = []

          for (let itemDetail of item.tel_temp.split(',')) {
            if (itemDetail != "-1") {
              item.Tel.push({
                id: 0,
                title: itemDetail,
                code: '',
                dsc: '',
                del: false,
                DeletingProccess: false
              })
            }

          }
          item.tel_temp = '-1'
        }

        this.outter_KarshnasMasol.emit(this.DataList_KarshnasMasol)

      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }



  //#region  فرم رابط مسئول

  RabetMasolCustomer: FormGroup;

  get_Form_RabetMasol_FName() {
    return this.RabetMasolCustomer.get('FName') as FormControl;
  }

  get_Form_RabetMasol_LName() {
    return this.RabetMasolCustomer.get('LName') as FormControl;
  }

  get_Form_RabetMasol_Sex() {
    return this.RabetMasolCustomer.get('Sex') as FormControl;
  }

  get_Form_RabetMasol_Semat() {
    return this.RabetMasolCustomer.get('Semat') as FormControl;
  }

  get_Form_RabetMasol_Mobile() {
    return this.RabetMasolCustomer.get('Mobile') as FormControl;
  }

  get_Form_RabetMasol_majaziMobile() {
    return this.RabetMasolCustomer.get('majaziMobile') as FormControl;
  }

  get_Form_RabetMasol_jaygozinMiblie() {
    return this.RabetMasolCustomer.get('jaygozinMiblie') as FormControl;
  }

  get_Form_RabetMasol_Tel() {
    return this.RabetMasolCustomer.get('Tel') as FormControl;
  }

  get_Form_RabetMasol_Id() {
    return this.RabetMasolCustomer.get('id') as FormControl;
  }

  get_Form_RabetMasol_Dsc() {
    return this.RabetMasolCustomer.get('Dsc') as FormControl;
  }

  get_Form_RabetMasol_Type() {
    return this.RabetMasolCustomer.get('Type') as FormControl;
  }

  get_Form_SmsActive() {
    return this.RabetMasolCustomer.get('SmsActive') as FormControl;
  }

  //#endregion

  //#region  کارشناس مسئول

  RabetMasolCustomer_Tel: Array<General_Interface> = []
  OnAdd_RabetMasolCustomer_Tel() {

    var Exited: boolean = false
    for (let item of this.RabetMasolCustomer_Tel) {
      if (item.title == this.get_Form_RabetMasol_Tel().value) {
        Exited = true;
        break
      }
    }


    if (this.RabetMasolCustomer_Tel.length == 3) {
      this.Alerify.ErrorMessage("امکان ثبت بیش از 3 تلفن نیست!")
    }
    else if (Exited) {
      this.Alerify.ErrorMessage("تلفن در لیست وجود دارد")
    }
    else {
      var temp: General_Interface = Empty_General_Interface()
      temp.title = this.get_Form_RabetMasol_Tel().value
      this.RabetMasolCustomer_Tel.push(temp)
      this.get_Form_RabetMasol_Tel().setValue("")
      this.Alerify.SuccessMessage("تلفن در لیست ثبت شد")
    }
  }
  RabetMasolCustomer_Tel_Delete(id) {
    this.RabetMasolCustomer_Tel.splice(id, 1)
    this.Alerify.SuccessMessage("تلفن از لیست  حذف شد")
  }

  //#endregion

  //#region  جدول کارشناس مسئول

  DataList_KarshnasMasol: Array<KarshnasMasol_Interface> = []
  OnSubmit_KarshnasMasolForm() {

    var temp: KarshnasMasol_Interface = Empty_KarshnasMasol_Interface()
    temp.id = 0
    temp.fname = this.get_Form_RabetMasol_FName().value
    temp.lname = this.get_Form_RabetMasol_LName().value
    temp.sex = Number(this.get_Form_RabetMasol_Sex().value)
    temp.semat = this.get_Form_RabetMasol_Semat().value
    temp.dsc = this.get_Form_RabetMasol_Dsc().value
    temp.mobile = this.get_Form_RabetMasol_Mobile().value
    temp.jaygozinMiblie = this.get_Form_RabetMasol_jaygozinMiblie().value
    temp.majaziMobile = this.get_Form_RabetMasol_majaziMobile().value
    temp.type = Number(this.get_Form_RabetMasol_Type().value)
    temp.smsActive = Number(this.get_Form_SmsActive().value) == 1
    temp.Tel = this.RabetMasolCustomer_Tel
    temp.smsActive = Number(this.get_Form_SmsActive().value) == 1


    if (!this.Check_KarshnasMasolForm(temp, this.KarshnasMasolForm_Edit_Id)) {
      this.Alerify.ErrorMessage("اطلاعات کارشناس مسئول در لیست موجود است")
    }
    else if (this.KarshnasMasolForm_Edit_Id == -1) {
      if (this.DataList_KarshnasMasol.length < 20) {
        this.DataList_KarshnasMasol.push(temp)

        this.RabetMasolCustomer.reset();

        this.get_Form_RabetMasol_Type().setValue("0")
        this.get_Form_SmsActive().setValue("0")

        this.RabetMasolCustomer_Tel = []

        this.Alerify.SuccessMessage("کارشناس مسئول به لیست اضافه شد")
      }
      else {
        this.Alerify.ErrorMessage("امکان ثبت بیش از 20 کارشناس مسئول نیست!")
      }
    }

    else {
      //this.DataList_KarshnasMasol[this.KarshnasMasolForm_Edit_Id].id=this.get_Form_RabetMasol_Id().value
      this.DataList_KarshnasMasol[this.KarshnasMasolForm_Edit_Id].fname = temp.fname
      this.DataList_KarshnasMasol[this.KarshnasMasolForm_Edit_Id].lname = temp.lname
      this.DataList_KarshnasMasol[this.KarshnasMasolForm_Edit_Id].sex = temp.sex
      this.DataList_KarshnasMasol[this.KarshnasMasolForm_Edit_Id].semat = temp.semat
      this.DataList_KarshnasMasol[this.KarshnasMasolForm_Edit_Id].dsc = temp.dsc
      this.DataList_KarshnasMasol[this.KarshnasMasolForm_Edit_Id].Email = temp.Email
      this.DataList_KarshnasMasol[this.KarshnasMasolForm_Edit_Id].mobile = temp.mobile
      this.DataList_KarshnasMasol[this.KarshnasMasolForm_Edit_Id].jaygozinMiblie = temp.jaygozinMiblie
      this.DataList_KarshnasMasol[this.KarshnasMasolForm_Edit_Id].majaziMobile = temp.majaziMobile
      this.DataList_KarshnasMasol[this.KarshnasMasolForm_Edit_Id].Dakhli = temp.Dakhli
      this.DataList_KarshnasMasol[this.KarshnasMasolForm_Edit_Id].Tel = temp.Tel
      this.DataList_KarshnasMasol[this.KarshnasMasolForm_Edit_Id].type = temp.type
      this.DataList_KarshnasMasol[this.KarshnasMasolForm_Edit_Id].smsActive = temp.smsActive
      this.Alerify.SuccessMessage("کارشناس مسئول ویرایش شد")
      this.KarshnasMasolForm_Edit_Id = -1

      this.RabetMasolCustomer.reset();

      this.get_Form_RabetMasol_Type().setValue("0")
      this.get_Form_SmsActive().setValue("0")


      this.RabetMasolCustomer_Tel = []
    }

    this.outter_KarshnasMasol.emit(this.DataList_KarshnasMasol)

  }

  Check_KarshnasMasolForm(Record: KarshnasMasol_Interface, index: number) {
    for (let item of this.DataList_KarshnasMasol) {
      if (this.DataList_KarshnasMasol.indexOf(item) == index) {

      }
      else if ((item.fname == Record.fname && item.lname == Record.lname) || item.mobile == Record.mobile) {
        return false
      }
    }
    return true
  }

  KarshnasMasolForm_Delete(id) {
    this.DataList_KarshnasMasol.splice(id, 1)
    this.Alerify.SuccessMessage(" حذف شد")
    this.outter_KarshnasMasol.emit(this.DataList_KarshnasMasol)
  }

  KarshnasMasolForm_Edit_Id: number = -1
  KarshnasMasolForm_Edit(id) {
    this.KarshnasMasolForm_Edit_Id = id

    var temp = this.DataList_KarshnasMasol[id]
    this.RabetMasolCustomer_Tel = temp.Tel

    this.get_Form_RabetMasol_Mobile().setValue(temp.mobile)
    this.get_Form_RabetMasol_jaygozinMiblie().setValue(temp.jaygozinMiblie)
    this.get_Form_RabetMasol_majaziMobile().setValue(temp.majaziMobile)

    this.get_Form_RabetMasol_Id().setValue(temp.id)
    this.get_Form_RabetMasol_Semat().setValue(temp.semat)
    this.get_Form_RabetMasol_FName().setValue(temp.fname)
    this.get_Form_RabetMasol_LName().setValue(temp.lname)
    this.get_Form_RabetMasol_Sex().setValue(temp.sex)
    this.get_Form_RabetMasol_Dsc().setValue(temp.dsc)
    
    this.get_Form_SmsActive().setValue("0")
    if(temp.smsActive==true)
      this.get_Form_SmsActive().setValue("1")
  }

  KarshnasMasolForm_Edit_Cancel() {
    this.KarshnasMasolForm_Edit_Id = -1
    this.get_Form_RabetMasol_Id().setValue(0)
    this.get_Form_RabetMasol_Semat().setValue("")
    this.get_Form_RabetMasol_Dsc().setValue("")

    this.get_Form_RabetMasol_Mobile().setValue("")
    this.get_Form_RabetMasol_jaygozinMiblie().setValue("")
    this.get_Form_RabetMasol_majaziMobile().setValue("")
  }

  //#endregion

  //#region سمت کارشناس مسئول

  DataList_Semat: Array<General_Interface> = []
  ReadSemat() {
    this.Customer_Service.GetKarshnas_Type().subscribe(
      data => {
        this.DataList_Semat = data

        if (this.inner_Customer > 0)
          this.OnInitail_Form()
      }
    )
  }

  Shitch_KarshnasType: boolean = true
  Shitch_KarshnasType_click() {
    this.get_Form_RabetMasol_Semat().setValue("")
    this.Shitch_KarshnasType = !this.Shitch_KarshnasType
  }

  //#endregion

}
